import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../../Common/InputText';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import Toggle from '../../Common/Toggle/Toggle';

export default class DepartmentForm extends React.Component {
    constructor(props, context) {
        super(props, context);

    }

    onTextChange = (e) => {
        this.props.onFormChange(e.target.name, e.target.value);
    }

    onToggleChange = (name, value) => {
        this.props.onFormChange(name, value);
    }

    onDisciplineChange = (id) => {
        this.props.onFormChange("disciplineId", id);
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit();
        return false;
    }

    render() {

        const alertClassList = (this.props.showWarning) ? "alert alert-warning" : "d-none";

        return (
            <div className="identifier-form">
                <form noValidate className={this.props.isFormValid ? "" : "was-validated"} onSubmit={this.onSubmit}>
                    <InputText name="name" label="Name" placeholder="Name" type="text" value={this.props.department.name} onChange={this.onTextChange} isRequired={true} errorMessage="Name is required" />
                    <MultiSelectBox name="discipline" label="Discipline" idField="id" valueField="name"
                        options={this.props.disciplines}
                        selectedValues={this.props.department.disciplineId.toString()}
                        onChange={this.onDisciplineChange}
                        isRequired={true}
                        errorMessage="Discipline is required"
                        isMulti={false}
                    />
                    {
                        (this.props.department.id !== 0 && this.props.department.disciplineId === 0)
                            ?
                            <div className='alert alert-warning' role="alert">Please select a discipline. The previously selected discipline is no longer active.</div>
                            :
                            null
                    }
                    <Toggle name="isActive" text="Active" checked={this.props.department.isActive} onChange={this.onToggleChange} />
                    <div className={alertClassList} role="alert">Caution: Tasks associated with Inactive departments should be updated to an active Department!</div>
                </form>
            </div>
        );
    }

}

DepartmentForm.propTypes = {
    disciplines: PropTypes.array.isRequired,
    onFormChange: PropTypes.func.isRequired, // returns (field, value)
    isFormValid: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    showWarning: PropTypes.bool.isRequired,
    department: PropTypes.object
}
